<script>
import 'leaflet/dist/leaflet.css'; // necessary CSS dependency
import L from 'leaflet';


export default {
	name: 'LeafletMap',
	inheritAttrs: false,
	provide() {
		return {
			leaflet: L,
			state: this.state
		};
	},
	props: { bounds: { type: [ Array, Object ] }, animate: { type: Boolean, default: true } },
	data() {
		return {
			ref: null,
			observer: null,
			state: {
				map: null,
				popup: {
					component: null,
					visible: false,
				},
				tooltip: {
					component: null,
					visible: false
				}
			}
		};
	},
	computed: {
		map: {
			get() {
				return this.state.map;
			},
			set(value) {
				this.state.map = value;
			}
		}
	},
	watch: {
		bounds(newVal) {
			if (!this.map || !newVal || !this.isBoundsValid(newVal)) return;
			this.zoomToBounds();
		}
	},
	async beforeDestroy() {
		await this.$nextTick();
		this.map.off();
		this.map.remove();
		this.map = null;
		this.observer.disconnect();
		this.observer = null;
	},
	mounted() {
		this.ref = this.$parent.$el;
		if (!this.map) {
			this.map = new L.map(this.ref, {
				center: [ 63, 12 ],
				zoom: 4,
				zoomControl: false,
				preferCanvas: true,
				renderer: L.canvas(),
				minZoom: 3,
				//maxBounds: L.latLngBounds([-90, -180], [90, 180]),
				worldCopyJump: true
			});

			this.observer = new ResizeObserver(() => this.map.invalidateSize());
			this.observer.observe(this.ref);
			this.observer.observe(document.body);

			this.map.on('moveend', this.map.invalidateSize);

			for (let event of [
				'autopanstart',
				'baselayerchange',
				'click',
				'contextmenu',
				'dblclick',
				'keydown',
				'keypress',
				'keyup',
				'layeradd',
				'layerremove',
				'load',
				'locationerror',
				'locationfound',
				'mousedown',
				'mousemove',
				'mouseout',
				'mouseover',
				'mouseup',
				'move',
				'moveend',
				'movestart',
				'overlayadd',
				'overlayremove',
				'popupclose',
				'popupopen',
				'preclick',
				'resize',
				'tooltipclose',
				'tooltipopen',
				'unload',
				'viewreset',
				'zoom',
				'zoomanim',
				'zoomend',
				'zoomlevelschange',
				'zoomstart',
			]) {
				this.map.on(event, (e) => this.$emit(event, e, this.state.map));
			}
		}
		if (this.isBoundsValid(this.bounds)) {
			this.zoomToBounds();
		}

		this.$nextTick(() => this.map.invalidateSize());
	},
	methods: {
		isBoundsValid(bounds) {
			if (bounds && bounds.isValid) return bounds.isValid();
			if (bounds && Array.isArray(bounds)) {
				if (Array.isArray(bounds[0])) return true;
				return bounds[0] && bounds[0].lat && bounds[0].lng;
			}
			return false;
		},
		zoomToBounds() {
			if (this.isBoundsValid(this.bounds)) {
				if (this.animate) {
					this.map.flyToBounds(this.bounds);
				} else {
					this.map.fitBounds(this.bounds);
				}
			}
		},
		addLayer(layer) {
			if (layer) this.map.addLayer(layer);
		}
	},
	render(createElement) {
		if (!this.ref) return null;
		return createElement('div', this.$scopedSlots.default({}));
	}
};

</script>

<style>
.map {
	width: 100%;
	height: 100%;
}

</style>
